/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-04-04",
    versionChannel: "nightly",
    buildDate: "2023-04-04T00:18:48.984Z",
    commitHash: "549a06d00f0da2fea49b252d70131ee46b0f9869",
};
